import React from 'react';
import PropTypes from 'prop-types';


function CardCalculationHeader({ cardImageURL, cardName }) {
    return (
        <>
            <div className="rh-display-flex rh-align-items-center rh-py-1 rh-px-1_5">
                <img
                    src={cardImageURL}
                    alt=""
                    width="50"
                />
                <h2
                    className="rh-title-3xs rh-ml-1"
                    data-test-name="card-name"
                >
                    {cardName}
                </h2>
            </div>
            <hr className="rh-horizontal-rule rh-mt-0 rh-mb-1 rh-mx-1_5" />
        </>
    );
}

CardCalculationHeader.propTypes = {
    cardImageURL: PropTypes.string.isRequired,
    cardName: PropTypes.string.isRequired,
};


export default CardCalculationHeader;
